// src/reducers/fashionphotos_reducer.js
import {
  FASHIONPHOTOS_REQUEST,
  FASHIONPHOTOS_SUCCESS,
  FASHIONPHOTOS_FAILURE,
} from "../actions/fashionphoto_actions";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export default function fashionphotosReducer(state = initialState, action) {
  switch (action.type) {
    case FASHIONPHOTOS_REQUEST:
      return { ...state, loading: true, error: null };
    case FASHIONPHOTOS_SUCCESS:
      return { ...state, loading: false, items: action.items || [], error: null };
    case FASHIONPHOTOS_FAILURE:
      return { ...state, loading: false, error: action.error || "Error" };
    default:
      return state;
  }
}
